import { Injectable } from '@angular/core';
import { Controller, ControllerSummary } from './controller';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { BaseIndexedDbRepository } from 'libs/arch/src/lib/repositories/indexed-db/indexdb-repository';
import { SynchronizationService } from 'libs/arch/src/lib/repositories/indexed-db/synchronization.service';

@Injectable({ providedIn: 'root' })
export class ControllersRepository extends BaseIndexedDbRepository<
    ControllerSummary,
    Controller
> {

    protected readonly storeName: string = 'controllers';

    protected getResourcePath(): string {
        return 'controllers';
    }

    protected getSearchableFields(): string[] {
        return ['name', 'code', 'identificationNumber', 'email', 'producer.id'];
    }

    protected override mapToEntity(dbItem: Controller): Controller {
        return Controller.fromJson(dbItem);
    }

    protected mapToSummary(item: Controller): ControllerSummary {
        return new ControllerSummary(item.id, item.name);
    }

    constructor(
        protected override readonly dbService: NgxIndexedDBService,
        protected override readonly synchronizationService: SynchronizationService
    ) {
        super(dbService, synchronizationService);
    }

}
